module.exports = __webpack_public_path__ + "static/images/tag.b2e7514da47a59c239b174580dc832f0.svg";